<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :form="form"
    :title="$t('model.requestLog')"
    resource="request_logs"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/request_logs.js';

@Component
export default class RequestLogs extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'target_id_eq',
      'target_type_eq',
      'url_cont',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'target_id',
      'target_type',
      // 'title',
      'url',
      type === 'show' && {
        key: 'params',
        renderCell(h, { props: { value } }) {
          return <pre>{ JSON.stringify(value, undefined, 2) }</pre>
        }
      },
      type === 'show' && {
        key: 'response',
        renderCell(h, { props: { value } }) {
          return <pre>{ JSON.stringify(value, undefined, 2) }</pre>
        }
      },
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'target_id',
      'target_type',
      'title',
      'url',
      'params',
      'response',
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'request_logs.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'request_logs.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/request_logs',
    name: 'request_logs.index',
    component: RequestLogs,
    props: {
      type: 'index',
    }
  },
  {
    path: '/request_logs/new',
    name: 'request_logs.new',
    component: RequestLogs,
    props: {
      type: 'new',
    }
  },
  {
    path: '/request_logs/:id',
    name: 'request_logs.show',
    component: RequestLogs,
    props: {
      type: 'show',
    }
  },
  {
    path: '/request_logs/:id/edit',
    name: 'request_logs.edit',
    component: RequestLogs,
    props: {
      type: 'edit'
    }
  }
]
</script>
